import React from 'react';
import { PropTypes } from 'prop-types';

import ComponentIterator from '../../containers/ComponentIterator';

const TagsWrapper = ({ components, className }) => (
  <div className={`flex flex-wrap ${className}`}>
    {components.map((component, index) => (
      // TODO: if tag has id, change index > id and remove eslint-disable
      // eslint-disable-next-line react/no-array-index-key
      <div key={index} className={`${index !== components.length - 1 ? 'mr-1 sm:mb-1' : ''}`}>
        <ComponentIterator components={[component]} />
      </div>
    ))}
  </div>
);

TagsWrapper.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  components: PropTypes.array.isRequired,
  className: PropTypes.string,
};

TagsWrapper.defaultProps = {
  className: '',
};

export default TagsWrapper;
